<template>
<div>
    <Validate v-if="dmr === null"></Validate>
    <div v-else>
        <v-container fluid>
            <v-layout row>
            <v-flex sm6 style="margin-right:10px">
                <div>
                    <v-toolbar dense >
                        <v-toolbar-title>Beneficiary List</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                        </v-toolbar-items>
                    </v-toolbar>
                       <v-card v-for="item in benifylist" style="margin-top:5px">
                        <v-card-title style="padding-bottom:0px;">
                        <div>
                            <div>Name: {{ item.BENENAME }} </div>
                            <div>Bank: {{ item.BANKNAME }} </div>
                            <div>Acc No: {{item.ACCOUNTNO  }} </div>
                            <div>IFSC Code: {{ item.IFSCCODE }} </div>
                        </div>
                        </v-card-title>
                        <v-card-actions>
                        <v-btn flat color="success" @click="currentb = item; transfer = true;">Transfer</v-btn>
                        <v-btn flat color="info" @click="validate(item)">Validate</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat color="error" @click="remove(item)">remove</v-btn>
                        </v-card-actions>
                    </v-card>
                </div>
            </v-flex>
            <v-flex sm6 style="margin-left:10px">
                   <v-toolbar dense >
                        <v-toolbar-title> Add Beneficiary</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                        </v-toolbar-items>
                    </v-toolbar>
                    <div>
                        <v-text-field
                            type="text"
                            style="width:300px;margin:0 auto;height:60px;margin-top:20px"
                            label="Beneficiary Name"
                            v-model="bname"
                            solo
                        />          
                        <v-text-field
                            type="number"
                            style="width:300px;margin:0 auto;height:60px;"
                            label="Beneficiary Mobile"
                            v-model="bmobile"
                            solo
                        />          
                        <v-text-field
                            type="number"
                            style="width:300px;margin:0 auto;height:60px;"
                            label="Beneficiary Account Number"
                            v-model="baccount"
                            solo
                        />          
                        <v-text-field
                            type="text"
                            style="width:300px;margin:0 auto;height:60px;"
                            label="IFSC Code"
                            v-model="bifsccode"
                            solo
                        />          
                        <v-text-field
                            type="text"
                            style="width:300px;margin:0 auto;height:60px;"
                            label="Bank Name"
                            v-model="bbname"
                            solo
                        />          
                        <v-text-field
                            type="text"
                            style="width:300px;margin:0 auto;height:60px;"                            
                            label="Branch Name"
                            v-model="bbranch"
                            solo
                        />          
                        <div style="width:300px;margin:0 auto;height:60px;">
                            <v-btn color="primary" @click="addbeneficiary" style="width:300px;margin-left:0px;">Add Beneficiary</v-btn>
                        </div>
                    </div>

                </v-flex>
            </v-layout>
        </v-container>
    </div>
            <v-dialog
                v-model="transfer"
                persistent
                width="400">
                        <v-card >
                                <v-card-title>Transfer Money</v-card-title>
                                       <v-divider></v-divider>
                                        <v-card-title style="padding-bottom:0px;">
                                        <div style="margin-bottom:10px;">
                                            <div >Name: {{ currentb.BENENAME }} </div>
                                            <div>Bank: {{ currentb.BANKNAME }} </div>
                                            <div>Acc No: {{currentb.ACCOUNTNO  }} </div>
                                            <div>IFSC Code: {{ currentb.IFSCCODE }} </div>
                                        </div>
                                         </v-card-title>
                                         <v-layout row wrap>
                                         <v-flex sm6  >
                                        <v-radio-group style="margin-left:20px;" row v-model="type">
                                                <v-radio
                                                    label="IMPS"
                                                    value="imps"
                                                ></v-radio>
                                                <v-radio
                                                    label="NEFT"
                                                    value="neft"
                                                ></v-radio>
                                        </v-radio-group>
                                        </v-flex>
                                         <v-flex sm6>
                                        <v-text-field
                                            type="number"
                                            style="height:60px;width:180px;"
                                            label="Amount"
                                            v-model="amount"
                                            solo
                                        />          

                                        </v-flex>
                                        </v-layout>
                                        <v-card-title>
                                            <div >
                                                <div style="color:red">{{ dmrmessage }}</div>
                                            </div>                                        
                                        </v-card-title>
                                        <v-card-actions>
                                       <v-btn flat color="success" v-if="dmrmessage !== ''" @click="submit">Confirm and pay</v-btn>
                                        <v-btn flat color="info" v-else @click="dmrcharge">Transfer</v-btn>
                                        <v-spacer></v-spacer>
                                        <v-btn flat color="error" @click="transfer = false; currentb = {}">Cancel</v-btn>
                                        </v-card-actions>
                                </v-card>
        </v-dialog>
            <v-dialog
                v-model="otpcheck"
                persistent
                width="300" height="300">
                        <v-card >
                                <v-card-title>Enter OTP</v-card-title>
                                       <v-divider></v-divider>
                                        <v-card-text>
                                                <v-text-field
                                                type="number"
                                                style="width:200px;margin:0 auto;height:60px;"
                                                label="OTP"
                                                v-model="otp"
                                                solo
                                                />          
                                                <v-btn color="primary" @click="verifyotp" style="width:200px;margin-left:35px">Submit</v-btn>
                                        </v-card-text>

                                </v-card>
        </v-dialog>

    <Loader v-if="loader"></Loader>
</div>    
</template>
<script>
import Loader from '../components/Loader.vue'
import Validate from './Validate'
export default {
   data() {
       return {
           loader: false,
           transfer: false,
           otpcheck: false,
           type: 'imps',
           otp: "",
           benifylist: [],
           bname: "",
           bmobile: "",
           baccount: "",
           bifsccode: "",
           bbname: "",
           bbranch: "",
           currentb: {},
           amount: "",
           dmrmessage: ""
       }
   },
   computed:{
        user(){
            return this.$store.getters.user;
        },
        security(){
            return this.$store.getters.security;
        },
        dmr() {
            return this.$store.getters.dmr;
        }
   },
   watch: {
       dmr(val) {
           this.fetchbenify();
       },
       amount() {
           this.dmrmessage = ""
       }
   },
   methods: {
        submit() {
            let vm = this;
            if(vm.amount === "") return vm.notification("warn","Amount Required")
            if(vm.user==null || !vm.user.phone) return vm.notification("error","Login Required!")
            let send = vm.currentb.BENENAME+"-"+vm.currentb.BANKNAME+"-"+vm.currentb.BENEID+"-DMTF_QuickRecharge-"+vm.dmr.mobile_no
            let doc = {
                'MobileNo':vm.user.phone,
                'Password':vm.user.password,
                'RechargeType':"rr",
                'ServiceName':vm.type,
                'Amount':vm.amount,
                'RechargeNumber':send,
                'TransId':'NA',
                'Circle':"all",
                'AuthKey':vm.user.authkey,
                'Source':'json'
            }            
            vm.loader = true;
            vm.$store.dispatch("axiospost",{
                    url:"MakeRecharge",
                    data:doc,
            }).then(function (res) {
                    vm.loader = false;
                    if(res.data.Status === "True") {
                        return vm.notification("sucess",res.data.Message);                               
                    }
                   return vm.notification("error",res.data.Message);                               
             }).catch(function (error) {
                    console.log(error);                    
                    vm.notification("error",error);
                    vm.loader = false;
            })
        },
        dmrcharge() {
            let vm = this;
            if(vm.amount === "") return vm.notification("warn","Amount Required")
            let doc ={
                'MobileNo':vm.user.phone,
                'Password':vm.user.password,
                'AuthKey':vm.user.authkey,
                'Amount':vm.amount,
                'Source':'json'
            }
            vm.loader = true;
            vm.$store.dispatch("axiospost",{
                    url:"DMTF_Charge",
                    data:doc,
            }).then(function (res) {
                vm.loader = false;
                vm.dmrmessage = res.data.Message
                console.log(res)
            }).catch(function (error) {
                    vm.loader = false;
                    vm.notification("error",error);
            })
        },
        addbeneficiary() {
           let vm = this;
           if(vm.bname === "") return vm.notification("warn","Beneficiary Name Required")
           if(vm.bmobile === "") return vm.notification("warn","Beneficiary Mobile Required")
           if(vm.bmobile.length !== 10) return vm.notification("warn","Enter Valid Mobile");
           if(vm.baccount === "") return vm.notification("warn","Beneficiary Account Required")
           if(vm.bifsccode === "") return vm.notification("warn","Beneficiary IFSC Code Required")
           if(vm.bbname === "") return vm.notification("warn","Beneficiary Bank Name Required")
           if(vm.bbranch === "") return vm.notification("warn","Beneficiary Branch Required")
            let doc = {
                'MobileNo': vm.user.phone,
                'Customer_MobileNo': vm.dmr.mobile_no,
                'Beneficiary_Name': vm.bname,
                'Beneficiary_No': vm.bmobile,
                'Account_No':vm.baccount,
                'Ifsc':vm.bifsccode,
                'Bank_Name':vm.bbname,
                'Branch_Name':vm.bbranch,
                'Security_Key': vm.security,
            }
            vm.loader = true;
            vm.$store.dispatch("axiosdmrpost",{
                    url: "Add_Beneficiary",
                    data:doc,
            }).then(function (res) {
                    vm.fetchbenify();
                    vm.loader = false;
                    let data = res.data;
                    vm.bname = ""
                    vm.bmobile = ""
                    vm.baccount = ""
                    vm.bifsccode = ""
                    vm.bbname = ""
                    vm.bbranch = ""
                    if(data.STATUS = "FAILED"){
                        vm.notification("error",data.MESSAGE)
                        return;                
                    }
                    vm.notification("success",data.MESSAGE)
            }).catch(function(err){
                    vm.loader = false;
                    vm.notification("error",err.message)                
            })           
 
        },
        verifyotp() {
           let vm = this;
           if(vm.otp === "") return vm.notification("warn"," OTP Required")
           let doc = {
                'MobileNo':vm.dmr.mobile_no,
                'Beneficiary_Id':vm.currentb.BENEID,
                'OTP': vm.otp,
                'Security_Key':vm.security
            }
            vm.loader = true;
            vm.$store.dispatch("axiosdmrpost",{
                    url: "Delete_Beneficiary_VerifyOtp",
                    data:doc,
            }).then(function (res) {
                    vm.loader = false;
                    let data = res.data;
                    if(data.STATUS === "FAILED"){
                        vm.notification("error",data.MESSAGE);                
                        return;
                    }
                    vm.otpcheck = false;
                    vm.notification("success",data.MESSAGE);                   
                    vm.otp = ""
                    vm.fetchbenify();
            }).catch(function(err){
                    vm.loader = false;
                    vm.notification("error",err.message)                
            })      
        },
        fetchbenify(){
           let vm = this;
           let doc = {
                'MobileNo':vm.dmr.mobile_no,
                'Security_Key':vm.security,
            }
            vm.loader = true;
            vm.$store.dispatch("axiosdmrpost",{
                    url: "Beneficiary_List",
                    data:doc,
            }).then(function (res) {
                    vm.loader = false;
                    let data = res.data;
                    vm.benifylist = data.BENEFICIARYLIST;
                    console.log(data);
            }).catch(function(err){
                    vm.loader = false;
                    vm.notification("error",err.message)                
            })           
        },
        remove(item){
           let vm = this;
           vm.currentb = item;
           let doc = {
                'MobileNo':vm.dmr.mobile_no,
                'Beneficiary_Id':item.BENEID,
                'Security_Key':vm.security
            }
            vm.loader = true;
            vm.$store.dispatch("axiosdmrpost",{
                    url: "Delete_Beneficiary",
                    data:doc,
            }).then(function (res) {
                    vm.loader = false;
                    let data = res.data;
                    if(data.STATUS === "FAILED"){
                        vm.notification("error",data.MESSAGE);                
                        return;
                    }
                    vm.otpcheck = true;
                    vm.notification("success",data.MESSAGE);                   
//                    vm.fetchbenify();
            }).catch(function(err){
                    vm.loader = false;
                    vm.notification("error",err.message)                
            })           
        },

        validate(item){
           let vm = this;
           let doc = {
                'MobileNo':vm.dmr.mobile_no,
                'Security_Key':vm.security,
                'Beneficiary_Code':item.BENEID,
                'Customer_Name':item.BENENAME,
            }
            vm.loader = true;
            vm.$store.dispatch("axiosdmrpost",{
                    url: "Validate_Beneficiary",
                    data:doc,
            }).then(function (res) {
                    vm.loader = false;
                    let data = res.data;
                    if(data.STATUS === "FAILED"){
                        vm.notification("error",data.MESSAGE);                
                        return;
                    }
                    vm.fetchbenify();
                    vm.notification("success",data.MESSAGE);                

            }).catch(function(err){
                    vm.loader = false;
                    vm.notification("error",err.message)                
            })           
        },
        notification(type,message){
            this.$notify({
                    group: 'foo',
                    title: 'Important message',
                    text: message,
                    duration:5000, 
                    type:type               
            })
        },
   },
   mounted() {
   },
   components: { Loader, Validate}
}
</script>